import { Routes } from '@angular/router';
import AudiobooksComponent from './views/audiobooks/audiobooks.component';
import LoginComponent from './views/auth/login/login.component';
import RegisterComponent from './views/auth/register/register.component';
import ResetPasswordComponent from './views/auth/reset-password/reset-password.component';
import VerifyEmailComponent from './views/auth/verify-email/verify-email.component';
import ScreeningEscalationComponent from './views/screening-escalation/screening-escalation.component';
import SkAuthComponent from './views/auth/sk-auth/sk-auth.component';
import PartnerSignupComponent from './views/auth/partner-signup/partner-signup.component';
import PartnerSignupSuccessComponent from './views/auth/partner-signup-success/partner-signup-success.component';
import PartnersComponent from './views/partners/partners.component';
import PreVisitSsoComponent from './views/pre-visit/sso/pre-visit-sso.component';
import AvTestComponent from './views/av-test/av-test.component';
import BenuLoginLandingPageComponent from './views/benu/login-landing-page/benu-login-landing-page.component';
import BenuPrescriptionPurchaseLandingPageComponent from './views/benu/prescription-purchase-landing-page/benu-prescription-purchase-landing-page.component';
import BenuThankYouPageComponent from './views/benu/thank-you-page/benu-thank-you-page.component';
import BookingAddressComponent from './views/booking/booking-address.component';
import BookingCheckoutStatusComponent from './views/booking/booking-checkout-status.component';
import BookingCheckoutComponent from './views/booking/booking-checkout.component';
import BookingOfferCheckoutComponent from './views/booking/booking-offer-checkout.component';
import BookingInstantStatusComponent from './views/booking/booking-instant-status.component';
import BookingInstantComponent from './views/booking/booking-instant.component';
import BookingIntermediateDialogComponent from './views/booking/booking-intermediate-dialog.component';
import BookingMentalCheckUnavailableComponent from './views/booking/booking-mental-check-unavailable.component';
import BookingMentalCheckComponent from './views/booking/booking-mental-check.component';
import PrescriptionComponent from './views/booking/booking-prescription.component';
import BookingReservationComponent from './views/booking/booking-reservation.component';
import BookingServiceComponent from './views/booking/booking-service.component';
import MentalHealthServicesComponent from './views/booking/mental-health-services.component';
import BookingFailedComponent from './views/booking/result/booking-failed.component';
import BookingSuccessComponent from './views/booking/result/booking-success.component';
import BookingsTypeComponent from './views/bookings/bookings-type.component';
import BookingsComponent from './views/bookings/bookings.component';
import CallComponent from './views/call/call.component';
import ChatsComponent from './views/chats/chats.component';
import ChatBotIntroductionComponent from './views/chatbot/chatbot-introduction.component';
import PreVisitChatComponent from './views/pre-visit/chat/pre-visit-chat.component';
import ConciergeServiceComponent from './views/concierge/concierge-service.component';
import ConsentComponent from './views/consents/consents.component';
import CreateEmployeeSurveysView from './views/create-employee-surveys/create-employee-surveys.component';
import CreateEmployeeTrainingProgramComponent from './views/create-employee-training-program/create-employee-training-program.component';
import XRoadConsentServiceComponent from './views/consents/x-road-consent-service/x-road-consent-service.component';
import XRoadLocalConsentComponent from './views/consents/x-road-local-consent/x-road-local-consents.component';
import CorporateCustomersOnlyComponent from './views/corporate-customers-only/corporate-customers-only.component';
import CorporateInsuranceComponent from './views/corporate-insurance/corporate-insurance.component';
import DependentsComponent from './views/dependents/dependents.component';
import EmployeesComponent from './views/employees/employees.component';
import EmployeeSurveysView from './views/employee-surveys/employee-surveys.component';
import HistoryComponent from './views/history/history.component';
import HomeComponent from './views/home/home.component';
import HrDashboardComponent from './views/hr-dashboard/hr-dashboard.component';
import InsuranceComponent from './views/insurance/insurance.component';
import InsuranceClaimRequestComponent from './views/insurance-claim-request/insurance-claim-request.component';
import InsurancePolicySettingsComponent from './views/insurance-policy-settings/insurance-policy-settings.component';
import InvoicesComponent from './views/invoices/invoices.component';
import JoinRequestsComponent from './views/join-requests/join-requests.component';
import LimitsComponent from './views/limits/limits.component';
import MeditationAddOnComponent from './views/meditation-add-on/meditation-add-on.component';
import MyMentalProfileComponent from './views/my-mental-profile/my-mental-profile.component';
import PreVisitCardListComponent from './views/pre-visit/card-list/pre-visit-card-list.component';
import PreVisitGeneralServiceRequestComponent from './views/pre-visit/general-service-request/pre-visit-general-service-request.component';
import PreVisitInsertForPersonComponent from './views/pre-visit/insert-for-person/pre-visit-insert-for-person.component';
import PreVisitInsertForPersonListComponent from './views/pre-visit/insert-for-person/pre-visit-insert-for-person-list.component';
import PreVisitMentalCheckComponent from './views/pre-visit/mental-check/pre-visit-mental-check.component';
import PreVisitPrescriptionCheckoutComponent from './views/pre-visit/prescription-checkout/prescription-checkout.component';
import PreVisitRecordTicketForPersonComponent from './views/pre-visit/record-ticket-for-person/pre-visit-record-ticket-for-person.component';
import PrescriptionListComponent from './views/prescription-list/prescription-list.component';
import ProfileComponent from './views/profile/profile.component';
import PromoComponent from './views/promo/promo.component';
import ComplianceAssessmentActionComponent from './views/compliance-assessment-action/compliance-assessment-action.component';
import ComplianceAssessmentComponent from './views/compliance-assessment/compliance-assessment.component';
import ComplianceAssessmentResultsComponent from './views/compliance-assessment-results/compliance-assessment-results.component';
import RedirectUserComponent from './views/redirect-user/redirect-user.component';
import ScheduleConfigurationComponent from './views/schedule/schedule-configuration/schedule-configuration.component';
import ScheduleComponent from './views/schedule/schedule.component';
import SettingsComponent from './views/settings/settings.component';
import SpSettingsComponent from './views/sp-settings/sp-settings.component';
import DoctorDetailsComponent from './views/specialist/specialist-details.component';
import SurveyView from './views/survey/survey.component';
import SymptomCheckComponent from './views/symptom-check/symptom-check.component';
import SymptomCheckSimpleComponent from './views/symptom-check/symptom-check-simple.component';
import TherapyFundWalletsComponent from './views/therapy-fund-wallets/therapy-fund-wallets.component';
import TransactionsComponent from './views/transactions/transactions.component';
import WalletComponent from './views/wallet/wallet.component';
import MyToolkitComponent from './views/my-toolkit/my-toolkit.component';
import AssignedToolkitResourceComponent from './views/assigned-toolkit-resource/assigned-toolkit-resource.component';
import ToolkitEek2HistoryComponent from './views/eek2-history/eek2-history.component';
import ToolkitComponent from './views/toolkit/toolkit.component';
import ToolkitAssignComponent from './views/toolkit-assign/toolkit-assign.component';
import ToolkitPreviewComponent from './views/toolkit-preview/toolkit-preview.component';
import ToolkitAssessmentAssignComponent from './views/toolkit-assessment-assign/toolkit-assessment-assign.component';
import ToolkitAssessmentPreviewComponent from './views/toolkit-assessment-preview/toolkit-assessment-preview.component';
import ToolkitClientComponent from './views/toolkit-client/toolkit-client.component';
import SpFeedbacksView from "./views/feedbacks/sp-feedbacks.component";
import TrainingProgramsComponent from './views/training-programs/training-programs.component';
import AssignedTrainingProgramsComponent from './views/assigned-training-programs/assigned-training-programs.component';
import TrainingProgramAnalyticsPageComponent from './views/training-program-analytics-page/training-program-analytics-page.component';
import {OverviewComponent} from "./training/pages/overview/overview.component";
import {ModuleLessonComponent} from "./training/pages/module-lesson/module-lesson.component";
import {QuizComponent} from "./training/pages/quiz/quiz.component";
import {ResultsComponent} from "./training/pages/results/results.component";
import {CertificateComponent} from "./training/pages/certificate/certificate.component";

export const APP_ROUTES: Routes = [
    { path:'audiobooks', component: AudiobooksComponent },
    { path:'login', component: LoginComponent },
    { path:'register', component: RegisterComponent },
    { path:'partner-signup', component: PartnerSignupComponent },
    { path:'partner-signup-success', component: PartnerSignupSuccessComponent },
    { path:'partners', component: PartnersComponent },
    { path:'reset-password', component: ResetPasswordComponent },
	{ path:'sk-auth', component: SkAuthComponent },
	{ path:'pre-visit-sso', component: PreVisitSsoComponent },
    { path:'verify-email', component: VerifyEmailComponent },
    { path:'tallinn', component: ScreeningEscalationComponent },
    { path:'av-test', component: AvTestComponent },
    { path:'benu/login', component: BenuLoginLandingPageComponent },
    { path:'benu/rets/:accessToken', component: BenuPrescriptionPurchaseLandingPageComponent },
    { path:'benu/thank-you', component: BenuThankYouPageComponent },
    { path:'booking/service/:serviceId/address', component: BookingAddressComponent },
    { path:'booking/checkout/:status', component: BookingCheckoutStatusComponent },
    { path:'booking/service/:serviceId/checkout', component: BookingCheckoutComponent },
    { path:'booking/offer/:bookingOfferId/checkout', component: BookingOfferCheckoutComponent },
    { path:'booking/instant/checkout', component: BookingCheckoutComponent },
    { path:'booking/prescription/checkout', component: BookingCheckoutComponent },
    { path:'booking/instant/:bookingId/:status', component: BookingInstantStatusComponent },
    { path:'booking/instant', component: BookingInstantComponent },
    { path:'booking/intermediate-dialog', component: BookingIntermediateDialogComponent },
    { path:'booking/mental-check-unavailable', component: BookingMentalCheckUnavailableComponent },
    { path:'booking/mental-check', component: BookingMentalCheckComponent },
    { path:'booking/prescription', component: PrescriptionComponent },
    { path:'booking/:reservationId/reservation', component: BookingReservationComponent },
    { path:'booking/service/:serviceId', component: BookingServiceComponent },
    { path:'mental-health-services', component: MentalHealthServicesComponent },
    { path:'booking-failed', component: BookingFailedComponent },
    { path:'booking-success', component: BookingSuccessComponent },
    { path:'bookings/:type', component: BookingsTypeComponent },
    { path:'bookings', component: BookingsComponent },
    { path:'call', component: CallComponent, outlet: 'fullscreen' },
    { path:'chats', component: ChatsComponent },
    { path:'chats/:id', component: ChatsComponent },
	{ path:'chatbot/:serviceId', component: ChatBotIntroductionComponent },
	{ path:'pre-visit-chat/:id', component: PreVisitChatComponent },
	{ path:'my-training/overview', component: OverviewComponent },
	{ path:'my-exercises', component: MyToolkitComponent },
	{ path:'my-exercises/resource/survey/:assignmentId/history', component: ToolkitEek2HistoryComponent },
	{ path:'my-exercises/resource/:kind/:assignmentId', component: AssignedToolkitResourceComponent },
	{ path:'my-exercises/resource/:assignmentId', component: AssignedToolkitResourceComponent },
	{ path:'my-exercises/exercise/:id', component: ToolkitPreviewComponent },
	{ path:'my-exercises/survey/:id', component: ToolkitAssessmentPreviewComponent },
    { path:'concierge/service/:serviceId', component: ConciergeServiceComponent },
    { path:'consents', component: ConsentComponent },
	{ path:'create-employee-surveys/:questionnaireCode', component: CreateEmployeeSurveysView },
	{ path:'compliance', component: ComplianceAssessmentComponent },
	{ path:'compliance/:questionnaireRequestId/results', component: ComplianceAssessmentResultsComponent },
	{ path:'compliance/:questionnaireRequestId/action-plan', component: ComplianceAssessmentResultsComponent },
    { path:'create-employee-training-program/:trainingProgramCode', component: CreateEmployeeTrainingProgramComponent },
    { path:'xroad/consent-service', component: XRoadConsentServiceComponent },
    { path:'xroad/consents', component: XRoadLocalConsentComponent },
    { path:'corporate/customers/limitation', component: CorporateCustomersOnlyComponent },
    { path:'corporate-insurance', component: CorporateInsuranceComponent },
    { path:'dependents', component: DependentsComponent },
    { path:'employees', component: EmployeesComponent },
	{ path:'employee-surveys', component: EmployeeSurveysView },
    { path:'history', component: HistoryComponent },
    { path:'', component: HomeComponent },
    { path:'dashboard', component: HrDashboardComponent },
    { path:'insurance', component: InsuranceComponent },
    { path:'insurance/:tabCode', component: InsuranceComponent },
    { path:'claim-request', component: InsuranceClaimRequestComponent },
    { path:'policy-settings', component: InsurancePolicySettingsComponent },
    { path:'invoices', component: InvoicesComponent },
    { path:'join-requests', component: JoinRequestsComponent },
    { path:'limits', component: LimitsComponent },
    { path:'meditation', component: MeditationAddOnComponent },
    { path:'my/wellbeing/profile', component: MyMentalProfileComponent },
    { path:'pre-visit', component: PreVisitCardListComponent },
    { path:'pre-visit/service/request', component: PreVisitGeneralServiceRequestComponent },
    { path:'pre-visit/insert-for-person', component: PreVisitInsertForPersonComponent },
	{ path:'pre-visit/insert-for-person-list', component: PreVisitInsertForPersonListComponent },
    { path:'pre-visit/mental-check', component: PreVisitMentalCheckComponent },
    { path:'pre-visit/prescription/checkout', component: PreVisitPrescriptionCheckoutComponent },
	{ path:'pre-visit/record-ticket-for-person', component: PreVisitRecordTicketForPersonComponent },
	{ path:'prescription-list', component: PrescriptionListComponent },
	{ path:'toolkit', component: ToolkitComponent },
	{ path:'toolkit/client/:id', component: ToolkitClientComponent },
	{ path:'toolkit/assessment/assign/:id', component: ToolkitAssessmentAssignComponent },
	{ path:'toolkit/assessment/preview/:id', component: ToolkitAssessmentPreviewComponent },
	{ path:'toolkit/assign/:kind/:id', component: ToolkitAssignComponent },
	{ path:'toolkit/preview/:kind/:id', component: ToolkitPreviewComponent },
    { path:'profile', component: ProfileComponent },
    { path:'promo', component: PromoComponent },
    { path:'compliance-assessment-action/:role/:token', component: ComplianceAssessmentActionComponent },
    { path:'redirect-user', component: RedirectUserComponent },
	{ path:'schedule/configure', component: ScheduleConfigurationComponent },
	{ path:'schedule', component: ScheduleComponent },
    { path:'settings', component: SettingsComponent },
    { path:'sp-settings', component: SpSettingsComponent },
    { path:'sp-feedbacks', component: SpFeedbacksView },
	{ path:'survey', component: SurveyView },
    { path:'specialist/:serviceId', component: DoctorDetailsComponent },
    { path:'symptom-check', component: SymptomCheckComponent },
    { path:'symptom-check/:id', component: SymptomCheckComponent },
	{ path:'symptom-check-simple', component: SymptomCheckSimpleComponent },
    { path:'therapy-fund-wallets', component: TherapyFundWalletsComponent },
    { path:'transactions', component: TransactionsComponent },
    { path:'wallet', component: WalletComponent },
    { path:'training-programs', component: TrainingProgramsComponent },
    { path:'training-programs/:id/analytics', component: TrainingProgramAnalyticsPageComponent },
    { path:'assigned-training-programs', component: AssignedTrainingProgramsComponent },
    { path: 'my-training/module/:moduleId', component: ModuleLessonComponent },
    { path: 'my-training/module/:moduleId/:sectionId', component: ModuleLessonComponent },
    { path: 'my-training/quiz/:moduleId', component: QuizComponent },
    { path: 'my-training/results/:moduleId', component: ResultsComponent },
    { path: 'my-training/certificate', component: CertificateComponent }
];
